export const applyAnimauxFilters = (annonce, filters) => {
  const { espece = [], prixMin, prixMax } = filters;

  const isEspeceFiltered =
    espece.length === 0 || espece.includes(annonce.espece);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax));

  return isEspeceFiltered && isPrixFiltered;
};
